import { render } from "./DashboardPage.vue?vue&type=template&id=f809a0bc&scoped=true"
import script from "./DashboardPage.vue?vue&type=script&lang=js"
export * from "./DashboardPage.vue?vue&type=script&lang=js"

import "./DashboardPage.vue?vue&type=style&index=0&id=f809a0bc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f809a0bc"],['__file',"src/views/ProductManage/ModelManagement/components/DashboardPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f809a0bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f809a0bc', __exports__)) {
    api.reload('f809a0bc', __exports__)
  }
  
  module.hot.accept("./DashboardPage.vue?vue&type=template&id=f809a0bc&scoped=true", () => {
    api.rerender('f809a0bc', render)
  })

}


export default __exports__